const segmentKey = segment => `${segment.segmentId}:${segment.dateRangeIndex || 0}`;

function filterSummaryResponses(responses = [], columns = [], filters = {}) {
  return responses.filter(row => columns.filter(column => !column.inactive && column.onFilter).every(column => {
    const key = column.key || (Array.isArray(column.dataIndex) ? column.dataIndex.join('.') : column.dataIndex);
    const values = Object.hasOwn(filters, key) ? filters[key] : column.defaultFilteredValue;
    return !values?.length || values.some(value => column.onFilter(value, row));
  }));
}

function summarySegments(segments, responses, selectedKeys) {
  return segments.filter(segment => (segment.dateRangeIndex || 0) === 0 && (!selectedKeys?.length || selectedKeys.includes(segmentKey(segment)))).map(segment => {
    const ids = new Set(segment.values);
    const rows = responses.filter(row => ids.has(row.id));
    return {
      segment,
      key: segmentKey(segment),
      responseIds: rows.map(row => row.id),
      revision: JSON.stringify(rows.map(row => [row.id, row.text, row.redactedAt, row.piiScan?.updatedAt, row.FlaggedComment?.id])),
    };
  });
}

module.exports = { segmentKey, filterSummaryResponses, summarySegments };
